import React, { useContext, useState } from 'react'
import '../App.css'
import { collection, query, where, getDocs, doc, setDoc, serverTimestamp, updateDoc,getDoc } from "firebase/firestore"
import { db } from '../config/firebase';
import { toast } from 'react-toastify';
import { AuthContext } from '../context/AuthContext';
const Search = () => {
  const [searchuser, setsearchuser] = useState(null)
  const [searhusername, setsearchusername] = useState("")
  const [iserror, setiserror] = useState(false)
  const {currentuser} = useContext(AuthContext)
  const handlesearch = async() =>{
    //  console.log(searhusername)
  const q = query(collection(db, "users"), where("displayName", "==", searhusername));

try{
  const querySnapshot = await getDocs(q);
console.log('querySnapshot:', querySnapshot);
querySnapshot.forEach((doc) => {
  console.log('doc:', doc);
  console.log(doc.id, " => ", doc.data());
  console.log(doc.data());
  setsearchuser(doc.data());

});

  }
  catch(err){
    setiserror(true)
    toast.error("User not found")
  }
};

const handleKey=(e) =>{
  e.code ==="Enter" && handlesearch();
}

const handleSelect = async() =>{
 
  const combinedId = currentuser.uid > searchuser.uid ? currentuser.uid+ searchuser.uid  : searchuser.uid + currentuser.uid;
  // check if the they have previous chat means if the db has previously stored theur id means they have chat
// Web are saving it in a combine id so that we can make it unique and know koun kisise baat krrha aur koun kiske chat me h
 try{
  const res = await getDoc(doc(db,"chats",combinedId));

  if(!res.exists()){
    // create the document 
    // We have tio make a document with the user id and then we create a field of combined id and tbeir we will store the data 
    await setDoc(doc(db,"chats", combinedId),{messages:[]})

    await updateDoc(doc(db,"userChats",currentuser.uid),{
      [combinedId+".userInfo"]: {
        uid: searchuser.uid,
        displayName : searchuser.displayName,
        photoURL : searchuser.photoURL,
      },
      [combinedId+".date"] : serverTimestamp(),
    });
  
    await updateDoc(doc(db,"userChats",searchuser.uid),{
      [combinedId+".userInfo"]: {
        uid: currentuser.uid,
        displayName : currentuser.displayName,
        photoURL : currentuser.photoURL,
      },
      [combinedId+".date"] : serverTimestamp(),
        
    });
  }

}catch(err){
  
  toast.error(err.message)
}
setsearchuser(null);
  setsearchusername("")
}


  return (
    <div className='search' >
      <div className="searchForm">
        <input type='text' placeholder='Find a user' onKeyDown={handleKey} onChange={(e)=>{ setsearchusername(e.target.value)}} value={searhusername}/>
      </div>
      {(iserror) && <span>User not found!</span>}
      {searchuser && <div className='userChat' onClick={handleSelect}>
        <img src={searchuser.photoURL} />
        <div className='userChatinfo'>
          <span>{searchuser.displayName}</span>
        </div>
      </div>
}
    </div>
  )
}

export default Search